/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SelectedCharacteristic = {
    selected: boolean;
    id: number;
    key: string;
    label: string;
    category: SelectedCharacteristic.category;
    verified: boolean;
};
export namespace SelectedCharacteristic {
    export enum category {
        ADMISSIONS = 'admissions',
        PROCEDURES = 'procedures',
        BILLING = 'billing',
        SERVICES = 'services',
        CORNERSTONES = 'cornerstones',
        EXCLUDED_CORNERSTONES = 'excludedCornerstones',
    }
}

